import { Dispatch } from "redux";

import api from "@helpers/api";

import { DemandStateAction } from "@reducers/types/procurements/demand-state";

import {
  GET_DEMAND,
  GET_SINGLE_DEMAND,
  CREATE_DEMAND,
  UPDATE_DEMAND,
  DELETE_DEMAND,
} from "./types";
import { DemandCreateType } from "@type/procurements/demand";
import {
  fetchDemand,
  fetchDemandById,
  createDemand,
  updateDemand,
  deleteDemand,
} from "@api/procurements/demand";

export const demandFetchActionHandler =
  (query: any) => async (dispatch: Dispatch<DemandStateAction>) => {
    dispatch({ type: GET_DEMAND.LOADING, payload: true });

    try {
      const res = await fetchDemand(query);

      const { data, page, size, total } = res.data || {};

      dispatch({
        type: GET_DEMAND.SUCCESS,
        payload: {
          data,
          pagination: {
            page,
            size,
            total,
          },
        },
      });
    } catch (err) {
      dispatch({ type: GET_DEMAND.ERROR, payload: err });
    }
  };

export const demandByIdFetchActionHandler =
  (id: string | number) => async (dispatch: Dispatch<DemandStateAction>) => {
    dispatch({ type: GET_SINGLE_DEMAND.LOADING, payload: true });

    try {
      const res = await fetchDemandById(id);

      dispatch({
        type: GET_SINGLE_DEMAND.SUCCESS,
        payload: res.data || {},
      });
    } catch (err) {
      dispatch({ type: GET_SINGLE_DEMAND.ERROR, payload: err });
    }
  };

export const demandCreateActionHandler =
  (data: DemandCreateType) => async (dispatch: Dispatch<DemandStateAction>) => {
    dispatch({ type: CREATE_DEMAND.LOADING, payload: true });

    try {
      const res = await createDemand(data);

      dispatch({ type: CREATE_DEMAND.SUCCESS, payload: res.data });
    } catch (err) {
      dispatch({ type: CREATE_DEMAND.ERROR, payload: err });
    }
  };

export const demandUpdateActionHandler =
  (id: string | number, data: { name: string; categoryId: number }) =>
  async (dispatch: Dispatch<DemandStateAction>) => {
    dispatch({ type: UPDATE_DEMAND.LOADING, payload: true });

    try {
      const res = await updateDemand(id, data);

      dispatch({
        type: UPDATE_DEMAND.SUCCESS,
        payload: res.data,
      });
    } catch (err) {
      dispatch({ type: UPDATE_DEMAND.ERROR, payload: err });
    }
  };

export const demandDeleteActionHandler =
  (id: string | number) => async (dispatch: Dispatch<DemandStateAction>) => {
    dispatch({ type: DELETE_DEMAND.LOADING, payload: true });

    try {
      const res = await deleteDemand(id);

      dispatch({ type: DELETE_DEMAND.SUCCESS, payload: res.data });
    } catch (err) {
      dispatch({ type: DELETE_DEMAND.ERROR, payload: err });
    }
  };
